import { Component, Input, EventEmitter, Output, OnDestroy,   LOCALE_ID, Inject } from '@angular/core';
import { MetadataService } from '../../metadata.service';
import { SelectableSettings, RowArgs } from '@progress/kendo-angular-grid';
import { State } from '@progress/kendo-data-query';
import { DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { GSPMetadataService } from '../../../metadata.service';
import { distinctUntilChanged, debounceTime } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { ProcessMode } from '../../processmode';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'app-metadatalist',
  templateUrl: './metadatalist.component.html',
  styleUrls: ['./metadatalist.component.css']
})
export class TemplatemetadataComponent implements OnDestroy {
  private subscriptions = [];
  // 分类
  classifier: any;
  // 技术栈
  codelanguage: string;
  // 处理模式
  processMode: ProcessMode;
  @Input() isMavenEnable: boolean;
  dotnet = 'dotnet';
  java = 'java';
  @Output() technologyStack = new EventEmitter();
  loading = false;
  @Input() typeName: string;
  @Input() filter: string;
  @Output() selectedMetadataChanged = new EventEmitter<any>();
  public LOCALES = {
    en: {
      "all": "All",
      "search": "Search",
      "engineeringName": "Engineering Name",
      "code": "Code",
      "name": "Name",
      "type": "Type",
      "metadataPackage": "Metadata Package",
      "belongNugetPackage": "Belonging NuGet Package",
      "nugetPackageVersion": "NuGet Package Version",
      "mavenGroupId": "Maven GroupId",
      "mavenArtifactId": "Maven ArtifactId",
      "mavenPackageVersion": "Maven Package Version",
      "loadMore": "Load More",
      "loading": "Loading...",
      "endOfList": "End of List"
    },
    "zh-CHS": {
      "all": "全部",
      "search": "搜索",
      "engineeringName": "工程名称",
      "code": "编号",
      "name": "名称",
      "type": "类型",
      "metadataPackage": "元数据包",
      "belongNugetPackage": "所属Nuget包",
      "nugetPackageVersion": "所属Nuget包版本",
      "mavenGroupId": "所属Maven包GroupId",
      "mavenArtifactId": "所属Maven包ArtifactId",
      "mavenPackageVersion": "所属Maven包版本",
      "loadMore": "加载更多",
      "loading": "加载中...",
      "endOfList": "已经到底了"
    },
    "zh-CHT": {
      "all": "全部",
      "search": "搜尋",
      "engineeringName": "工程名稱",
      "code": "編號",
      "name": "名稱",
      "type": "類型",
      "metadataPackage": "元數據包",
      "belongNugetPackage": "所屬NuGet包",
      "nugetPackageVersion": "所屬NuGet包版本",
      "mavenGroupId": "所屬Maven包GroupId",
      "mavenArtifactId": "所屬Maven包ArtifactId",
      "mavenPackageVersion": "所屬Maven包版本",
      "loadMore": "加載更多",
      "loading": "加載中...",
      "endOfList": "已經到底了"
    }
  };
  localeData = null;

  allSource = { text: this.LOCALES[localStorage.getItem('languageCode')  || 'zh-CHS'].all, value: 'All' };
  selectedSource = this.allSource;
  sourceList: Array<{ text: string, value: string }> = [this.allSource];
  popupSettings = { width: 'auto' };
  allowCustom = true;

  allType = { text: this.LOCALES[localStorage.getItem('languageCode')  || 'zh-CHS'].all, value: 'All' };
  selectedType = this.allType;
  typeList: Array<{ text: string, value: string }> = [
    this.allType
  ];
  postfixSelected = '';
  initPageIndex = 0;
  initPageSize = 10;
  page = {
    pageIndex: this.initPageIndex,
    pageSize: this.initPageSize
  };
  typeListReadonly = false;
  hasNext = true;
  searchText = '';
  searchTextForDup = '';
  searchTextSub = new Subject<string>();
  postfix = '';
  postfixFlag = true;
  scope = 0;
  data: any[];
  conflictAvoidFlag = false;
  reload = true;
  mySelection = [];
  clear() {
    this.data = [];
    this.selectionChanged(null, []);
    this.page = {
      pageIndex: this.initPageIndex,
      pageSize: this.initPageSize
    };
  }
  // tslint:disable-next-line:member-ordering
  public state: State = {
    skip: 0,
    take: 9999,
    // Initial filter descriptor
    filter: {
      logic: 'and',
      filters: []
    }
  };
  // public gridData: GridDataResult = this.data;
  // tslint:disable-next-line:member-ordering
  public gridData: any[];
  // tslint:disable-next-line:member-ordering
  selectableSetting: SelectableSettings = { mode: 'single', checkboxOnly: false };
  public dataStateChange(state: DataStateChangeEvent): void {
    this.state = state;
  }
  ngOnDestroy() {
    if (this.subscriptions && this.subscriptions.length > 0) {
      for (const item of this.subscriptions) {
        item.unsubscribe();
      }
    }
  }
  constructor(private metadataService: MetadataService, private gspMetaService: GSPMetadataService, @Inject(LOCALE_ID) private localeID: string) {
    this.localeID = localStorage.getItem('languageCode')  || 'zh-CHS';
    this.localeData = this.LOCALES[this.localeID];
    this.classifier = { id: '' };
    this.searchTextSub.pipe(debounceTime(2048), distinctUntilChanged()).subscribe(text => {
      this.searchText = text.trim();
      // 搜索
      this.getData();
    });

    // this.unsubscribeAll();
    const subscription = this.metadataService.selectedChange.subscribe(classifier => {
      if (this.classifier && classifier && this.classifier.id === classifier.id) { return; }
      // 元数据类型
      if (this.postfixFlag) {
        this.gspMetaService.GetMetadataTypeList().subscribe(typeList => {
          let count = 0;
          typeList.forEach(type => {
            this.postfixFlag = false;
            const typeNameArray = this.typeName.split(',');
            typeNameArray.forEach(typeName => {
              if (typeName.toLowerCase() === type.typeCode.toLowerCase()) {
                this.postfix = this.postfix + type.postfix + ',';
                this.typeList.push({ text: type.typeName, value: type.postfix });
                count++;
              }
            });
          });
          if (count === 1) {
            this.typeList.shift();
            this.selectedType = this.typeList[0];
            this.typeListReadonly = true;
          }
          this.postfixSelected = this.postfix;
          this.scopeChanged(classifier);
        }, error => {
          const msg = error.error.Message !== undefined ? error.error.Message : error.error.error.message;
          gsp.ide.messager.error('Fetch Metadata Type error:' + msg);
        });
      } else {
        this.scopeChanged(classifier);
      }

      // 技术栈赋值
      this.metadataService.getCodeLanguage().subscribe(item => {
        if (item) {
          // 如果目前工程非单栈，则获取环境默认技术栈
          if (item.indexOf(';') > -1) {
            this.gspMetaService.getSettingInfo().subscribe(setting => {
              if (setting && setting.technologyStack) {
                this.codelanguage = setting.technologyStack;
                this.technologyStack.emit(this.codelanguage);
                if (classifier.id === 'ref' || classifier.id === 'remote') {
                  if (this.codelanguage === 'dotnet' || this.isMavenEnable === false) {
                    this.initNugetSourceList();
                  } else {
                    this.initMavenSourceList();
                  }
                }
              } else if (this.isMavenEnable === true) {
                // 环境默认配置为空，则按照java技术栈处理
                this.codelanguage = 'java';
                this.technologyStack.emit(this.codelanguage);
                if (classifier.id === 'ref' || classifier.id === 'remote') {
                  this.initMavenSourceList();
                }
              } else {
                this.codelanguage = 'dotnet';
                this.technologyStack.emit(this.codelanguage);
                if (classifier.id === 'ref' || classifier.id === 'remote') {
                  this.initNugetSourceList();
                }
              }
            });
          } else {
            this.codelanguage = item;
            this.technologyStack.emit(this.codelanguage);
            if (classifier.id === 'ref' || classifier.id === 'remote') {
              if (this.codelanguage === 'dotnet' || this.isMavenEnable === false) {
                this.initNugetSourceList();
              } else {
                this.initMavenSourceList();
              }
            }
          }
        } else {
          // 工程的技术栈为空，则也是从环境默认技术栈读取
          this.gspMetaService.getSettingInfo().subscribe(setting => {
            if (setting && setting.technologyStack) {
              this.codelanguage = setting.technologyStack;
              this.technologyStack.emit(this.codelanguage);
              if (classifier.id === 'ref' || classifier.id === 'remote') {
                if (this.codelanguage === 'dotnet' || this.isMavenEnable === false) {
                  this.initNugetSourceList();
                } else {
                  this.initMavenSourceList();
                }
              }
            } else if (this.isMavenEnable === true) {
              // 环境默认配置为空，则按照java技术栈处理
              this.codelanguage = 'java';
              this.technologyStack.emit(this.codelanguage);
              if (classifier.id === 'ref' || classifier.id === 'remote') {
                this.initMavenSourceList();
              }
            } else {
              this.codelanguage = 'dotnet';
              this.technologyStack.emit(this.codelanguage);
              if (classifier.id === 'ref' || classifier.id === 'remote') {
                this.initNugetSourceList();
              }
            }
          });
        }
      });

      // 处理模式
      this.metadataService.getProcessMode().subscribe(processMode => {
        this.processMode = processMode;
      });
    });

    this.subscriptions.push(subscription);
  }

  initNugetSourceList() {
    if (this.sourceList.length === 1) {
      this.gspMetaService.getNugetSourceList().subscribe(sources => {
        sources.forEach(source => {
          this.sourceList.push({ text: source.name, value: source.name });
        });
      });
    }
  }
  initMavenSourceList() {
    if (this.sourceList.length === 1) {
      this.gspMetaService.getMavenSourceList().subscribe(sources => {
        if (sources.repoList) {
          sources.repoList.forEach(source => {
            this.sourceList.push({ text: source.id, value: source.id });
          });
        }
      });
    }
  }

  onSearchTextChanged() {
    if (!this.searchText) { this.searchText = ''; }
    const searchTextTrim = this.searchText.trim();
    if (this.searchTextForDup === searchTextTrim) {
      return;
    }
    this.searchTextForDup = searchTextTrim;
    this.searchTextSub.next(searchTextTrim);
  }

  rowSelected = (e: RowArgs) => this.mySelection.indexOf(e.index) >= 0;

  private GetMetadataList() {
    const metadatadto = [];
    this.loading = true;
    this.metadataService.GetMetadataList(this.postfixSelected).subscribe(templates => {
      this.loading = false;
      if (!templates) {
        this.gridData = this.data;
        gsp.ide.messager.error('error to get response');
        return;
      }
      // tslint:disable-next-line: prefer-for-of
      for (let index = 0; index < templates.length; index++) {
        const template = templates[index];
        if (this.searchText) {
          // tslint:disable-next-line: max-line-length
          if (template.code.indexOf(this.searchText) > -1 || template.name.indexOf(this.searchText) > -1) {
            metadatadto.push(template);
          }
        } else {
          metadatadto.push(template);
        }
      }
      if (metadatadto.length > 0) {
        this.onSelectionChangedInternal(metadatadto[0], [0]);
      }
      this.hasNext = false;
      this.data = metadatadto;
      this.gridData = this.data;
    }, error => {
      this.data = metadatadto;
      this.gridData = this.data;
      this.loading = false;
      const msg = error.error.Message !== undefined ? error.error.Message : error.error.error.message;
      gsp.ide.messager.error('Get Metadatas Error:' + msg);
    });
  }

  private GetMetadataListInBo() {
    const metadatadto = [];
    this.loading = true;
    this.metadataService.GetMetadataListInBo(this.postfixSelected).subscribe(templates => {
      this.loading = false;
      if (!templates) {
        this.gridData = this.data;
        gsp.ide.messager.error('error to get response');
        return;
      }
      // tslint:disable-next-line: prefer-for-of
      for (let index = 0; index < templates.length; index++) {
        const template = templates[index];
        if (this.searchText) {
          // tslint:disable-next-line: max-line-length
          if (template.projectName.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1
            || template.code.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1
            || template.name.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1) {
            metadatadto.push(template);
          }
        } else {
          metadatadto.push(template);
        }
      }
      if (metadatadto.length > 0) {
        this.onSelectionChangedInternal(metadatadto[0], [0]);
      }
      this.hasNext = false;
      this.data = metadatadto;
      this.gridData = this.data;
    }, error => {
      this.data = metadatadto;
      this.gridData = this.data;
      this.loading = false;
      const msg = error.error.Message !== undefined ? error.error.Message : error.error.error.message;
      gsp.ide.messager.error('Get Metadatas Error:' + msg);
    });

  }

  private GetLocalMetadataList(reloadT = true) {
    const metadatadto = [];
    this.loading = true;
    // this.gspMetaService.GetDevRootPath().subscribe(root => {
    // this.metadataService.rootPath = root;
    // tslint:disable-next-line:max-line-length
    this.metadataService.GetMetadataInfos(this.scope, this.codelanguage, this.isMavenEnable, this.postfixSelected, this.searchText, this.page).subscribe((templates: any) => {
      this.loading = false;
      if (!templates) {
        gsp.ide.messager.error('error to get metadata infos');
        return;
      }

      // 页码处理
      if (templates.page) {
        if (templates.page.pageSize < this.initPageSize) {
          this.hasNext = false;
        } else {
          this.hasNext = true;
        }
        this.page.pageSize = templates.page.pageSize;
        this.page.pageIndex = templates.page.pageIndex;
      } else {
        this.hasNext = false;
      }

      const metadataList = templates.metadataIndexItems;
      if (!metadataList || metadataList.length < 1) {
        this.mySelection = [];
        this.gridData = this.data;
        return;
      }

      metadataList.forEach(element => {
        if (element.repoPkg && element.repoPkg.length > 0) {
          element.nugetPkgName = element.repoPkg[0].name;
          element.nugetPkgVersion = element.repoPkg[0].version;
        }
        metadatadto.push(element);
      });
      if (reloadT) {
        this.onSelectionChangedInternal(metadatadto[0], [0]);
        this.data = metadatadto;
      } else {
        metadatadto.forEach(dto => {
          this.data.push(dto);
        });
      }
      this.gridData = this.data;
    }, error => {
      this.data = metadatadto;
      this.gridData = this.data;
      this.loading = false;
      const msg = error.error.Message !== undefined ? error.error.Message : error.error.error.message;
      gsp.ide.messager.error('Metadata req failed: ' + msg);
    });
  }

  public showOnlyBeveragesDetails(dataItem: any, index: number): boolean {
    return dataItem.repoPkg && dataItem.repoPkg.length > 1;
  }

  getRemoteMetadataList(reload) {
    const metadatadto = [];
    this.loading = true;
    // tslint:disable-next-line:max-line-length
    this.metadataService.GetMetadataInfos(this.scope, this.codelanguage, this.isMavenEnable, this.postfixSelected, this.searchText, this.page, this.selectedSource.value).subscribe((templates: any) => {
      this.loading = false;
      if (!templates) {
        gsp.ide.messager.error('error to get metadata infos');
        return;
      }

      // 页码处理
      if (templates.page) {
        if (templates.page.pageSize < this.initPageSize) {
          this.hasNext = false;
        } else {
          this.hasNext = true;
        }
        this.page.pageSize = templates.page.pageSize;
        this.page.pageIndex = templates.page.pageIndex;
      } else {
        this.hasNext = false;
      }

      const metadataList = templates.metadataIndexItems;
      if (!metadataList || metadataList.length < 1) {
        this.mySelection = [];
        this.gridData = this.data;
        return;
      }

      metadataList.forEach(element => {
        if (!element.repoPkg || element.repoPkg.length < 1) {
          return;
        }
        if (this.codelanguage === 'dotnet' || this.isMavenEnable === false) {
          element.repoPkg.sort(this.compareNuget('version'));
          element.nugetPkgName = element.repoPkg[0].name;
          element.nugetPkgVersion = element.repoPkg[0].version;
        } else {
          element.repoPkg.sort(this.compare('version'));
          element.groupId = element.repoPkg[0].groupId;
          element.artifactId = element.repoPkg[0].artifactId;
          element.mavenPkgVersion = element.repoPkg[0].version;
        }
        metadatadto.push(element);
      });
      if (!metadatadto || metadatadto.length < 1) {
        this.mySelection = [];
        this.gridData = this.data;
        return;
      }
      if (reload) {
        this.onSelectionChangedInternal(metadatadto[0], [0]);
        this.data = metadatadto;
      } else {
        metadatadto.forEach(dto => {
          this.data.push(dto);
        });
      }
      this.gridData = this.data;
    }, error => {
      this.data = metadatadto;
      this.gridData = this.data;
      this.loading = false;
      const msg = error.error.Message !== undefined ? error.error.Message : error.error.error.message;
      gsp.ide.messager.error('Metadata req failed: ' + msg);
    });
  }

  compare(pro) {
    return (obj1, obj2) => {
      const val1 = obj1[pro];
      const val2 = obj2[pro];
      const vala1 = val1.split('.');
      const vala2 = val2.split('.');
      const v10 = vala1[0].substr(1);
      const v20 = vala2[0].substr(1);
      if (Number(v10) < Number(v20)) {
        return 1;
      }
      if (Number(v10) > Number(v20)) {
        return -1;
      }
      if (Number(vala1[1]) < Number(vala2[1])) {
        return 1;
      }
      if (Number(vala1[1]) > Number(vala2[1])) {
        return -1;
      }
      const v12 = vala1[2].replace('-SNAPSHOT', '');
      const v22 = vala2[2].replace('-SNAPSHOT', '');
      if (Number(v12) < Number(v22)) {
        return 1;
      }
      if (Number(v12) > Number(v22)) {
        return -1;
      }
      if (vala1[2].indexOf('-SNAPSHOT') > 0) {
        return 1;
      } else {
        return -1;
      }
    };
  }

  compareNuget(pro) {
    return (obj1, obj2) => {
      const val1 = obj1[pro];
      const val2 = obj2[pro];
      const vala1 = val1.split('.');
      const vala2 = val2.split('.');
      const v10 = vala1[0];
      const v20 = vala2[0];
      if (Number(v10) < Number(v20)) {
        return -1;
      }
      if (Number(v10) > Number(v20)) {
        return 1;
      }
      if (Number(vala1[1]) < Number(vala2[1])) {
        return 1;
      }
      if (Number(vala1[1]) > Number(vala2[1])) {
        return -1;
      }
      const v12 = vala1[2];
      const v22 = vala2[2];
      if (v12.indexOf('alpha') > 0) {
        if (v12 < v22) {
          return 1;
        }
        if (v12 > v22) {
          return -1;
        }
      } else {
        if (Number(v12) < Number(v22)) {
          return 1;
        }
        if (Number(v12) > Number(v22)) {
          return -1;
        }
      }
    };
  }

  scopeChanged(classifier) {
    this.classifier = classifier;
    this.getData();
  }

  getData() {
    if (this.classifier) {
      if (this.reload) {
        this.clear();
      }
      const reloadT = this.reload;
      if (this.classifier.id === 'project') {
        this.scope = 0;
        this.GetMetadataList();
      } else if (this.classifier.id === 'bo') {
        this.scope = 0;
        this.GetMetadataListInBo();
      } else if (this.classifier.id === 'ref') {
        this.scope = 3;
        this.getRemoteMetadataList(reloadT);
      } else if (this.classifier.id === 'remote') {
        this.scope = 2;
        this.getRemoteMetadataList(reloadT);
      } else if (this.classifier.id === 'local') {
        this.scope = 1;
        this.GetLocalMetadataList(reloadT);
      } else if (this.classifier.id === 'db') {
      this.scope = 4;
      this.GetLocalMetadataList(reloadT);
    }

      // 重置一次请求中的状态
      this.reload = true;
    }
  }

  // 选中元数据后的事件处理
  onSelectionChange(event) {
    if (event && event.selectedRows && event.selectedRows.length > 0) {
      const dataItem = event.selectedRows[0].dataItem;
      this.onSelectionChangedInternal(dataItem, [event.selectedRows[0].index]);
    }
  }

  private onSelectionChangedInternal(dataItem, index) {
    const newData = this.makeNewData(dataItem);
    if (this.scope === 2 || this.scope === 3) {
      newData.repoPkg.push(dataItem.repoPkg[0]);
    }
    this.selectionChanged(newData, index);
  }

  private selectionChanged(dataItem, index = []) {
    this.selectedMetadataChanged.emit(dataItem);
    this.mySelection = index;
  }

  private makeNewData(dataItem) {
    return {
      mdPkgName: dataItem.mdPkgName,
      repoPkg: [],
      id: dataItem.id,
      nameSpace: dataItem.nameSpace,
      code: dataItem.code,
      name: dataItem.name,
      fileName: dataItem.fileName,
      type: dataItem.type,
      bizobjectID: dataItem.bizobjectID,
      language: dataItem.language,
      isTranslating: dataItem.isTranslating,
      relativePath: dataItem.relativePath,
      extendProperty: dataItem.extendProperty,
      processMode: dataItem.processMode
    };
  }
  onSelectedPkgChanged(dataItem) {
    if (dataItem && dataItem.repoPkg && dataItem.repoPkg.length > 0) {
      const newData = this.makeNewData(dataItem);
      if (dataItem.selectedPkg) {
        newData.repoPkg.push(dataItem.selectedPkg);
      } else {
        newData.repoPkg.push(dataItem.repoPkg[0]);
      }
      this.selectionChanged(newData, []);
    }
  }
  goSearch() {
    if (!this.searchText) { this.searchText = ''; }
    const searchTextTrim = this.searchText.trim();
    if (this.searchText && this.searchTextForDup === searchTextTrim) {
      return;
    }
    this.searchTextForDup = searchTextTrim;
    this.searchText = searchTextTrim;
    // 搜索
    this.getData();
  }

  goNext() {
    this.page.pageIndex = this.page.pageIndex + 1;
    this.reload = false;
    this.getData();
  }

  onConflictAvoidFlagChanged() {
    this.getData();
  }

  typeSelectedChanged(mdSeleted) {
    if (!mdSeleted) {
      mdSeleted = this.selectedType;
    }
    if (mdSeleted) {
      if (mdSeleted.value === this.allType.value) {
        this.postfixSelected = this.postfix;
      } else {
        this.postfixSelected = mdSeleted.value;
      }
      this.getData();
    }
  }

  sourceSelectedChanged(source) {
    if (!source) {
      source = this.selectedSource;
    }
    this.selectedSource = source;
    this.getData();
  }
}
